export const cashToCloseHeadingLabels = [
  { label: 'Borrower', align: 'left' },
  { label: 'Loan Estimate', align: 'right' },
  { label: 'Final', align: 'right' },
];

const cashToCloseDataSections = {
  totalClosingCosts: 'totalClosingCosts',
  closingCostsPaidBeforeClosing: 'closingCostsPaidBeforeClosing',
  closingCostsFinanced: 'closingCostsFinanced',
  downPaymentFromBorrower: 'downPaymentFromBorrower',
  deposit: 'deposit',
  fundsForBorrower: 'fundsForBorrower',
  sellerCredits: 'sellerCredits',
  adjustmentsAndOtherCredits: 'adjustmentsAndOtherCredits',
  loanAmount: 'loanAmount',
  totalPayoffsAndPayments: 'totalPayoffsAndPayments',
};

export const cashToCloseDataSectionsMap = {
  [cashToCloseDataSections.totalClosingCosts]: 'Total Closing Costs (J)',
  [cashToCloseDataSections.closingCostsPaidBeforeClosing]: 'Closing Costs Paid Before Closing',
  [cashToCloseDataSections.closingCostsFinanced]:
    'Closing Costs Financed (Paid from your Loan Amount)',
  [cashToCloseDataSections.downPaymentFromBorrower]: 'Down Payment/Funds from Borrower',
  [cashToCloseDataSections.deposit]: 'Deposit',
  [cashToCloseDataSections.fundsForBorrower]: 'Funds for Borrower',
  [cashToCloseDataSections.sellerCredits]: 'Seller Credits',
  [cashToCloseDataSections.adjustmentsAndOtherCredits]: 'Adjustments and Other Credits',
  [cashToCloseDataSections.loanAmount]: 'Loan Amount',
  [cashToCloseDataSections.totalPayoffsAndPayments]: 'Total Payoffs and Payments (K)',
};

export const purchaseFeesFlowKeys = [
  cashToCloseDataSections.totalClosingCosts,
  cashToCloseDataSections.closingCostsPaidBeforeClosing,
  cashToCloseDataSections.closingCostsFinanced,
  cashToCloseDataSections.downPaymentFromBorrower,
  cashToCloseDataSections.deposit,
  cashToCloseDataSections.fundsForBorrower,
  cashToCloseDataSections.sellerCredits,
  cashToCloseDataSections.adjustmentsAndOtherCredits,
];

export const refinanceFeesFlowKeys = [
  cashToCloseDataSections.loanAmount,
  cashToCloseDataSections.totalClosingCosts,
  cashToCloseDataSections.closingCostsPaidBeforeClosing,
  cashToCloseDataSections.totalPayoffsAndPayments,
];
